import React, { useRef } from "react";
import "./index.scss";

export interface ImageSlot {
  file: File | null;
  preview: string | null;
  deleted: boolean;
  fromServer: boolean;
}

interface Props {
  slot: ImageSlot;
  slotIndex: number;
  onChangeImage: (slotIndex: number, file: File) => void;
  onDeleteImage: (slotIndex: number) => void;
}

const AnimationIconComponent: React.FC<Props> = ({
  slot,
  slotIndex,
  onChangeImage,
  onDeleteImage,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    onChangeImage(slotIndex, file);
    e.target.value = "";
  };

  return (
    <div className="image-slot-row">
      {/* ✅ IMAGE LEFT */}
      <div className="image-box" onClick={openFilePicker}>
        {slot.preview && !slot.deleted ? (
          <img src={slot.preview} alt={`slot-${slotIndex}`} />
        ) : (
          <div className="empty-placeholder">
            <i className="bx bx-image-add" />
            <span>Image {slotIndex + 1}</span>
          </div>
        )}
      </div>

      {/* ✅ ICONS RIGHT (NEXT TO IMAGE) */}
      <div className="image-side-actions">
        <button type="button" className="icon-btn" onClick={openFilePicker}>
          <i className="bx bx-repost" />
        </button>

        <button
          type="button"
          className="icon-btn danger"
          onClick={() => onDeleteImage(slotIndex)}
        >
          <i className="bx bx-trash" />
        </button>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={handleFileChange}
      />
    </div>
  );
};

export default AnimationIconComponent;
